module.exports = __webpack_public_path__ + "static/media/marco-faseth.b75e9be8.jpg";